export const ApplicationVariantEnum = {
  BackOffice: 'VeloBackOfficePortal',
  PayorPortal: 'VeloPayorPortal',
  PayeePortal: 'VeloPayeePortal',
  VeloOpenBankingPayins: 'VeloOpenBankingPayins',
  VeloOpenBankingPayinsAdmin: 'VeloOpenBankingPayinsAdmin',
};
